
// Import the functions you need from the SDKs you need
import firebase from 'firebase/compat/app';
//import firebase from "firebase";
import "firebase/compat/database";
import "firebase/compat/storage";
import "firebase/compat/auth";
import "firebase/compat/firestore"
import "firebase/compat/messaging"
import "firebase/compat/app-check"
//import "firebase/compat/messaging"

const config = {
    apiKey: "AIzaSyCvROOILYiFDDvVR5YVR-m-p3Dn-gSAj0Y",
    authDomain: "wwsmbc.firebaseapp.com",
    projectId: "wwsmbc",
    storageBucket: "wwsmbc.firebasestorage.app",
    messagingSenderId: "860933335864",
    appId: "1:860933335864:web:a29eef7acc60cafe596fcd",
    measurementId: "G-2K3GS5JCY3"
};





firebase.initializeApp(config);
// const db=firebase.database();
export const db = firebase.database();
export const storage = firebase.storage();
export const auth = firebase.auth();
//export const auth = firebase.auth();
//export const firestore = firebase.firestore()
//export const firebases = firebase;